<template>
  <AppLayout>
    <div class="main">
      <template v-if="product">
        <div class="header mb-8">
          <h2>{{ product.code }}</h2>
          <a :href="downloadUrl" target="_blank">Download</a>
        </div>

        <div class="flex flex-row flex-wrap gap-2">
          <ProductImage
            v-for="image in images"
            :key="image.id"
            :product-id="route.params.id.toString()"
            :image="image"
            v-model:selected-images="selectedImages"
          />
        </div>
      </template>
    </div>
  </AppLayout>
</template>
<script setup lang="ts">
import { useApi } from '@/composables/api';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import AppLayout from '@/components/AppLayout.vue';
import ProductImage from '@/modules/products/product-detail/ProductImage.vue';
import type { ImageDto, ProductDto } from '@/api/generated';

const api = useApi();
const route = useRoute();

const product = ref<ProductDto>();

const selectedImages = ref<string[]>([]);

const downloadUrl = computed(() => {
  let query = '';
  if (selectedImages.value.length) {
    query = '?' + selectedImages.value.map(id => `id=${id}`).join('&');
  }
  return `/api/products/${route.params.id}/download-images${query}`;
});

async function loadProduct() {
  product.value = await api.get<ProductDto>(`/products/${route.params.id}`);
}
loadProduct();

// async function uploadImages() {
//   try {
//     uploading.value = true;

//     let order = max(images.value.map(image => image.order)) ?? -1;
//     const labelNumbers = images.value
//       .map(image => {
//         const m = image.label.match(/^photo_(\d{2})$/);
//         return m ? Number(m[1]) : undefined;
//       })
//       .filter(n => Boolean(n));
//     let labelNumber = max(labelNumbers) ?? 0;

//     const uploads = [];

//     for (const file of files.value) {
//       order++;
//       labelNumber++;
//       const label = `photo_${String(labelNumber).padStart(2, '0')}`;
//       uploads.push(uploadImage(file, order, label));
//     }

//     await Promise.all(uploads);
//   } finally {
//     uploading.value = false;
//   }
// }

// async function uploadImage(file: File, order: number, label: string) {
//   // TODO: neresim error handling

//   const imageId = uuid.v4();
//   const body = await file.arrayBuffer();
//   await api.putBuffer<Image>(
//     `/products/${route.params.id}/images/${imageId}?order=${order}&label=${label}`,
//     // `/products/${route.params.id}/images/${imageId}?autoEdit=true`,
//     file.type,
//     body,
//   );

//   files.value = [];

//   await loadImages();
// }

const images = ref<ImageDto[]>([]);

async function loadImages() {
  images.value = await api.get<ImageDto[]>(`/products/${route.params.id}/images`);
}

// function selectAll() {
//   if (selectedImages.value.length === images.value.length) {
//     selectedImages.value = difference(
//       selectedImages.value,
//       images.value.map(image => image.id),
//     );
//   } else {
//     selectedImages.value = images.value.map(image => image.id);
//   }
// }

loadImages();
</script>
